// extracted by css-extract-rspack-plugin
export default {"TagContainer":"pAMtz","TagName":"YXzcQ","Parameter":"BfM30"};